import type { TCreditFormCommonFields, TCreditFormDictionaries } from 'entities/creditForm';

export const findEmployerTypeByOpfCode = (
  opfCode: string,
  employerTypeDictionary: TCreditFormDictionaries['employerTypes'],
): TCreditFormCommonFields['employerType'] => {
  return employerTypeDictionary.find(({ data }) => data?.meta === opfCode);
};
